import {
  ApplicationCategoryEnum,
  IntegrationAvailabilityEnum,
  OrganizationApplication as OrganizationApplicationDto,
} from '@electricjs/core_entity-client';

import { employeeIdsWithAppChampionRole } from '@/mocks/data/employeeData';
import { SLACK_SUB_RESOURCE_APP_ID } from '@/mocks/data/groupChangeSubResourceData';
import { simpleOrganization } from '@/mocks/data/organizationData';
import { Application, OrganizationApplication } from '@/types/applications';

export const organizationApplicationsList: OrganizationApplicationDto[] = [
  // Slack — host app for the Group Change sub-resource picker mock (offboarding
  // automated so the Removed From action reads "Will revoke access").
  {
    id: 'b1a82950-9a81-4e19-92d8-3f2ec4ced299',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: SLACK_SUB_RESOURCE_APP_ID,
      name: 'Slack',
      slug: 'slack',
      icon: 'https://software-applications-logos.s3.amazonaws.com/supported-applications/Slack.png',
      integration_availability: 'not_available',
      category: 'productivity_collaboration',
    },
    onboarding_automation_on: true,
    offboarding_automation_on: true,
    integration_connected: true,
    integration_status: 'CONNECTED',
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: 'b1a82950-9a81-4e19-92d8-3f2ec4ced28b',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: '002df5c0-054f-11ee-be56-0242ac120002',
      name: '1Password',
      slug: '1password',
      icon: 'https://software-applications-logos.s3.amazonaws.com/supported-applications/1Password.png',
      integration_availability: 'not_available',
      category: 'it_security',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: '5ea82950-9a81-4e19-92d8-3f2ec4ced28a',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: '002df5c0-054f-11ee-be56-0242ac120003',
      name: '99 Designs',
      slug: '99_Designs',
      icon: 'https://software-applications-logos.s3.amazonaws.com/supported-applications/99-Designs.png',
      url: 'https://en.99designs.com.br/',
      integration_availability: 'not_available',
      category: 'design_creative',
    },
    onboarding_automation_on: true,
    offboarding_automation_on: true,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: '5ea82950-9a81-4e19-92d8-3f2ec4ced28a',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: '002df5c0-054f-11ee-be56-0242ac120003',
      name: '99 Designs',
      slug: '99_Designs',
      icon: 'https://software-applications-logos.s3.amazonaws.com/supported-applications/99-Designs.png',
      url: 'https://en.99designs.com.br/',
      integration_availability: 'not_available',
      category: 'design_creative',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: '5ea82950-9a81-4e19-92d8-3f2ec4ced28a',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: '002df5c0-054f-11ee-be56-0242ac120003',
      name: '99 Designs',
      slug: '99_Designs',
      icon: 'https://software-applications-logos.s3.amazonaws.com/supported-applications/99-Designs.png',
      url: 'https://en.99designs.com.br/',
      integration_availability: 'not_available',
      category: 'design_creative',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: '5ea82950-9a81-4e19-92d8-3f2ec4ced28a',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: '002df5c0-054f-11ee-be56-0242ac120003',
      name: '99 Designs',
      slug: '99_Designs',
      icon: 'https://software-applications-logos.s3.amazonaws.com/supported-applications/99-Designs.png',
      url: 'https://en.99designs.com.br/',
      integration_availability: 'not_available',
      category: 'design_creative',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: 'a8cd1c0f-42f3-4a80-9fb3-82b31f1af76a',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: '13e20646-1322-4493-8417-8993e77332cc',
      name: 'Teams',
      slug: 'teams',
      icon: '',
      url: 'https://teams.microsoft.com',
      integration_availability: 'not_available',
      category: 'productivity_collaboration',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: 'a8cd1c0f-42f3-4a80-9fb3-82b31f1af76a',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: '13e20646-1322-4493-8417-8993e77332cc',
      name: 'Teams',
      slug: 'teams',
      icon: '',
      url: 'https://teams.microsoft.com',
      integration_availability: 'not_available',
      category: 'productivity_collaboration',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: 'a8cd1c0f-42f3-4a80-9fb3-82b31f1af76a',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: '13e20646-1322-4493-8417-8993e77332cc',
      name: 'Teams',
      slug: 'teams',
      icon: '',
      url: 'https://teams.microsoft.com',
      integration_availability: 'not_available',
      category: 'productivity_collaboration',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: 'a8cd1c0f-42f3-4a80-9fb3-82b31f1af76a',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: '13e20646-1322-4493-8417-8993e77332cc',
      name: 'Teams',
      slug: 'teams',
      icon: '',
      url: 'https://teams.microsoft.com',
      integration_availability: 'not_available',
      category: 'productivity_collaboration',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: 'f2831e4d-e0f3-4118-8bf7-35d2f5af8163',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: 'aaeea7bc-054e-11ee-be56-0242ac120002',
      name: 'Zoom',
      slug: 'zoom',
      icon: '',
      url: 'https://zoom.us',
      integration_availability: 'not_available',
      category: 'productivity_collaboration',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: 'f2831e4d-e0f3-4118-8bf7-35d2f5af8163',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: 'aaeea7bc-054e-11ee-be56-0242ac120002',
      name: 'Zoom',
      slug: 'zoom',
      icon: '',
      url: 'https://zoom.us',
      integration_availability: 'not_available',
      category: 'productivity_collaboration',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: 'f2831e4d-e0f3-4118-8bf7-35d2f5af8163',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: 'aaeea7bc-054e-11ee-be56-0242ac120002',
      name: 'Zoom',
      slug: 'zoom',
      icon: '',
      url: 'https://zoom.us',
      integration_availability: 'not_available',
      category: 'productivity_collaboration',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  {
    id: 'f2831e4d-e0f3-4118-8bf7-35d2f5af8163',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: 'aaeea7bc-054e-11ee-be56-0242ac120002',
      name: 'Zoom',
      slug: 'zoom',
      icon: '',
      url: 'https://zoom.us',
      integration_availability: 'not_available',
      category: 'productivity_collaboration',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: false,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
  // Microsoft On-Prem Active Directory — exercises the Service Principal
  // Object ID / Provisioning Job ID fields (TF-494), sourced from `metadata`.
  {
    id: 'c3b4d5e6-1234-4a5b-8c9d-0e1f2a3b4c5d',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: 'c3b4d5e6-1234-4a5b-8c9d-0e1f2a3b4c5e',
      name: 'Microsoft On-Prem Active Directory',
      slug: 'microsoft-on-prem-active-directory',
      icon: '',
      integration_availability: 'not_available',
      category: 'it_security',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: true,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {
      service_principal_id: '5f8d0d55-1c1a-4f6e-9e4a-2b7c6d1a9f3e',
      provisioning_job_id: 'a1b2c3d4-e5f6-4789-9abc-def012345678',
    },
  },
  // Microsoft Entra ID — connected so the Profile Sync section renders
  // (TF-892); see supportedProfileFieldsByApplication in integrationData.ts.
  {
    id: 'd4c5e6f7-2345-4b6c-9d0e-1f2a3b4c5d6e',
    organization: simpleOrganization,
    created_at: '2021-10-01T00:00:00.000Z',
    updated_at: '2021-10-01T00:00:00.000Z',
    application: {
      id: 'd4c5e6f7-2345-4b6c-9d0e-1f2a3b4c5d6f',
      name: 'Microsoft Entra ID',
      slug: 'microsoft-entra-id',
      icon: '',
      integration_availability: 'not_available',
      category: 'it_security',
    },
    onboarding_automation_on: false,
    offboarding_automation_on: false,
    integration_connected: true,
    disable_create_account_requests: false,
    disable_delete_account_requests: false,
    is_hris_source: false,
    metadata: {},
  },
];

/**
 * Maps an employee id to the set of `application.slug` values they champion.
 * Used by the mock `getOrganizationApplications` handler when filtering by
 * `champion_employee_id` (the ChampionReassignment offboarding step's query).
 *
 * Derived from the offboarding scenario fixtures so adding a new
 * `hasAppChampionRole: true` scenario automatically wires up app championship
 * here. The championed apps are intentionally the same set for every scenario
 * employee — the page only needs *some* apps to surface for `isChampion`.
 */
export const appChampionsByEmployeeId: Record<string, string[]> =
  Object.fromEntries(
    Array.from(employeeIdsWithAppChampionRole).map(id => [
      id,
      ['teams', 'zoom'],
    ])
  );

export const createOrganizationApplication = {
  id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
  application: {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    name: 'string',
    slug: 'string',
    icon: 'string',
    url: 'string',
    organization_id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    integration_availability: 'string' as IntegrationAvailabilityEnum,
    category: 'other' as ApplicationCategoryEnum,
  },
  organization: {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    name: 'string',
  },
  url: 'string',
  created_at: '2023-06-09T20:41:08.128Z',
  updated_at: '2023-06-09T20:41:08.128Z',
  onboarding_automation_on: false,
  offboarding_automation_on: false,
  integration_connected: false,
  disable_create_account_requests: false,
  disable_delete_account_requests: false,
  is_hris_source: false,
  metadata: {},
};

export const createTestOrganizationApplication = (
  overrides: Partial<OrganizationApplication> = {},
  applicationOverrides: Partial<Application> = {}
): OrganizationApplication => ({
  id: 'org-app-1',
  application: {
    id: 'app-1',
    name: 'Test App',
    slug: 'test-app-1',
    integrationAvailability: IntegrationAvailabilityEnum.All,
    category: ApplicationCategoryEnum.Other,
    ...applicationOverrides,
  },
  organization: {
    id: 'org-1',
    name: 'Test Org',
  },
  onboardingAutomationOn: false,
  offboardingAutomationOn: false,
  createdAt: '2023-01-01T00:00:00Z',
  updatedAt: '2023-01-01T00:00:00Z',
  integrationConnected: false,
  disableCreateAccountRequests: false,
  disableDeleteAccountRequests: false,
  ...overrides,
});
